import { ReactNode } from 'react';
import {
  FormControl,
  FormControlLabel,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
} from '@mui/material';
import { modifiers } from '@outdoria/ui';

import s from './RadioGroup.module.scss';

type RadioGroupProps<V> = {
  name: string;
  label?: string;
  value: V;
  setValue: (value: V) => void;
  data: { value: V; label: ReactNode; disabled?: boolean }[];
};
export const RadioGroup = <V extends string>({
  name,
  label,
  value,
  setValue,
  data,
}: RadioGroupProps<V>) => {
  const onSelect = (newValue: V) => {
    if (setValue) setValue(newValue);
  };

  return (
    <FormControl id="radio-group" className={s.radioGroup__wrapper}>
      {label && (
        <label htmlFor="radio-group" className={s.radioGroup__label}>
          {label}
        </label>
      )}
      <MuiRadioGroup className={s.radioGroup__group} value={value} id={name}>
        {data.map(item => (
          <FormControlLabel
            key={item.value}
            value={item.value}
            label={item.label}
            onChange={() => onSelect(item.value)}
            classes={{
              root: modifiers(s, 'radio__wrapper', {
                isChecked: value === item.value,
              }),
              label: modifiers(s, 'radio__icon', {
                isChecked: value === item.value,
              }),
            }}
            control={
              <MuiRadio disabled={item.disabled} classes={{ root: s.radio }} />
            }
          />
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};
